import { render } from "./v-transaction-details.vue?vue&type=template&id=0dfae3a7"
import script from "./v-transaction-details.vue?vue&type=script&lang=js"
export * from "./v-transaction-details.vue?vue&type=script&lang=js"

import "./v-transaction-details.vue?vue&type=style&index=0&id=0dfae3a7&lang=css"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__